"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ReduxSelect;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = require("lodash");
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _reactSelect = _interopRequireWildcard(require("react-select"));
var _utils = require("../../../utils");
var _OptionWithCheckbox = _interopRequireDefault(require("./OptionWithCheckbox"));
var _excluded = ["selectProps"],
  _excluded2 = ["autoFocus", "canDeleteInitialValue", "children", "className", "closeMenuOnSelect", "disabled", "fixedHeight", "fullWidth", "helperText", "id", "input", "isClearable", "isMulti", "label", "loadingIndicator", "maxOptions", "meta", "onChange", "options", "removeSelected", "showCheckboxes", "showSelectAll", "sortOptions", "sortValue", "style"];
var _FormattedMessage, _FormattedMessage2;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    chip: {
      margin: '2px 1px',
      maxWidth: 'calc(100% - 2px)'
    },
    chipFocused: {
      backgroundColor: (0, _styles.emphasize)(theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[700], 0.08)
    },
    chipLabel: {
      display: 'inline-block',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      width: '100%'
    },
    chipLabelHide: {
      paddingRight: 0
    },
    disabled: {
      color: theme.palette.text.disabled
    },
    divider: {
      height: theme.spacing(2)
    },
    inlineText: {
      maxWidth: 'calc(100% - 1px)',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    },
    inlineTextWithSearch: {
      maxWidth: 'calc(100% - 6px)'
    },
    input: {
      animation: 'none',
      display: 'flex',
      height: 'auto',
      padding: 0
    },
    loadingIndicator: {
      padding: '12px',
      position: 'relative',
      top: '3px'
    },
    noOptionsMessage: {
      padding: theme.spacing(1, 2)
    },
    option: {
      '&:hover': {
        backgroundColor: "".concat(theme.palette.action.hover, " !important")
      }
    },
    paper: {
      marginTop: theme.spacing(1),
      position: 'absolute',
      width: '100%',
      zIndex: 1060
    },
    placeholder: {
      display: 'contents',
      left: 2,
      position: 'relative'
    },
    root: {
      flexGrow: 1
    },
    selectionContainer: {
      alignItems: 'center',
      boxSizing: 'border-box',
      display: 'flex',
      flex: 1,
      maxWidth: '100%',
      minHeight: 49,
      minWidth: 1,
      padding: '7px 12px 6px'
    },
    selectionValue: {
      alignItems: 'center',
      display: 'flex',
      flexShrink: 1,
      minWidth: 1
    },
    textBox: {
      '& > label': {
        display: 'block',
        maxWidth: 'calc(100% - 60px)'
      },
      display: 'block'
    },
    valuesContainer: {
      '&.no-wrap': {
        flexWrap: 'nowrap'
      },
      alignItems: 'center',
      display: 'inline-flex',
      flexWrap: 'wrap',
      maxWidth: '100%'
    },
    valueText: {
      display: 'block',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      width: '100%'
    }
  };
});
var getParamsForValueContainerWithChecboxes = function getParamsForValueContainerWithChecboxes(selectProps) {
  var _selectProps$initialV, _selectProps$value;
  var initialValueLength = ((_selectProps$initialV = selectProps.initialValue) == null ? void 0 : _selectProps$initialV.length) || 0;
  var valueLength = (_selectProps$value = selectProps.value) == null ? void 0 : _selectProps$value.length;
  var newValueLength = valueLength - initialValueLength;
  var showValue = selectProps.valueCountTranslationKey && !!valueLength;
  var showInitialValue = selectProps.initialValueCountTranslationKey && !!initialValueLength;
  var showNewValue = selectProps.initialValueCountTranslationKey && !!newValueLength;
  var selectedCount = showValue && valueLength || showInitialValue && initialValueLength;
  return {
    chipsVisible: !!selectedCount || showNewValue && showInitialValue,
    initialValueLength,
    newValueLength,
    selectedCount,
    showInitialValue,
    showNewValue,
    showValue,
    valueLength
  };
};
function NoOptionsMessage(_ref) {
  var selectProps = _ref.selectProps,
    innerProps = _ref.innerProps;
  return /*#__PURE__*/_react.default.createElement(_material.Typography, (0, _extends2.default)({
    className: selectProps.classes.noOptionsMessage,
    color: "textSecondary",
    variant: "body2"
  }, innerProps), _FormattedMessage || (_FormattedMessage = /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    defaultMessage: "No options",
    id: "select.text.noOptions"
  })));
}
var inputComponent = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    ref: ref
  }, props));
});
function Control(_ref2) {
  var children = _ref2.children,
    notEmpty = _ref2.hasValue,
    innerProps = _ref2.innerProps,
    innerRef = _ref2.innerRef,
    isDisabled = _ref2.isDisabled,
    isFocused = _ref2.isFocused,
    selectProps = _ref2.selectProps;
  var classes = useStyles();
  var _getParamsForValueCon = getParamsForValueContainerWithChecboxes(selectProps),
    chipsVisible = _getParamsForValueCon.chipsVisible;
  var showCheckboxes = selectProps.showCheckboxes;
  return /*#__PURE__*/_react.default.createElement(_material.TextField, (0, _extends2.default)({
    className: classes.textBox,
    disabled: isDisabled,
    InputLabelProps: {
      shrink: !!(notEmpty || isFocused || showCheckboxes && chipsVisible)
    },
    InputProps: (0, _extends2.default)({
      inputComponent,
      inputProps: (0, _extends2.default)({
        children,
        className: selectProps.classes.input
      }, innerProps),
      inputRef: innerRef
    }, selectProps.TextFieldInputProps),
    variant: "outlined"
  }, selectProps.TextFieldProps));
}
function Option(_ref3) {
  var children = _ref3.children,
    data = _ref3.data,
    innerProps = _ref3.innerProps,
    isDisabled = _ref3.isDisabled,
    isFocused = _ref3.isFocused,
    isSelected = _ref3.isSelected;
  var theme = (0, _material.useTheme)();
  var classes = useStyles();
  var id = data.id,
    selectAll = data.selectAll;
  return /*#__PURE__*/_react.default.createElement(_material.MenuItem, (0, _extends2.default)({
    className: classes.option,
    component: "div",
    disabled: isDisabled,
    selected: isFocused,
    style: (0, _extends2.default)({
      fontWeight: isSelected ? 500 : 400,
      whiteSpace: 'inherit'
    }, selectAll && {
      borderBottom: "2px solid ".concat(theme.palette.action.disabled),
      fontWeight: 500
    })
  }, innerProps, {
    id: id
  }), children);
}
function Placeholder(_ref4) {
  var children = _ref4.children,
    innerProps = _ref4.innerProps,
    selectProps = _ref4.selectProps;
  return /*#__PURE__*/_react.default.createElement(_material.Typography, (0, _extends2.default)({
    className: selectProps.classes.placeholder,
    color: "textSecondary",
    variant: "body1"
  }, innerProps), children);
}
function SingleValue(_ref5) {
  var children = _ref5.children,
    isDisabled = _ref5.isDisabled,
    innerProps = _ref5.innerProps,
    selectProps = _ref5.selectProps;
  return /*#__PURE__*/_react.default.createElement(_material.Typography, (0, _extends2.default)({
    className: (0, _classnames.default)({
      [selectProps.classes.disabled]: isDisabled,
      [selectProps.classes.inlineText]: (0, _utils.hasValue)(selectProps.fixedHeight),
      [selectProps.classes.inlineTextWithSearch]: (0, _utils.hasValue)(selectProps.fixedHeight) && selectProps.isSearchable !== false
    }),
    variant: "body1"
  }, innerProps), children);
}
function ValueContainer(_ref6) {
  var children = _ref6.children,
    selectProps = _ref6.selectProps;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: selectProps.classes.selectionContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(selectProps.classes.valuesContainer, {
      'no-wrap': !selectProps.isMulti && !selectProps.menuIsOpen
    })
  }, children));
}
function MultiValue(_ref7) {
  var children = _ref7.children,
    data = _ref7.data,
    isDisabled = _ref7.isDisabled,
    isFocused = _ref7.isFocused,
    removeProps = _ref7.removeProps,
    selectProps = _ref7.selectProps;
  return /*#__PURE__*/_react.default.createElement(_material.Chip, (0, _extends2.default)({
    classes: {
      label: selectProps.classes.chipLabel,
      root: (0, _classnames.default)(selectProps.classes.chip, {
        [selectProps.classes.chipFocused]: isFocused,
        [selectProps.classes.disabled]: isDisabled
      })
    },
    label: children,
    onDelete: function onDelete(event) {
      removeProps.onClick();
      removeProps.onMouseDown(event);
    },
    tabIndex: -1
  }, (data == null ? void 0 : data.color) && {
    color: data.color
  }));
}
function Empty() {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
}
function ValueContainerWithChecboxes(_ref8) {
  var children = _ref8.children,
    selectProps = _ref8.selectProps;
  var _getParamsForValueCon2 = getParamsForValueContainerWithChecboxes(selectProps),
    initialValueLength = _getParamsForValueCon2.initialValueLength,
    newValueLength = _getParamsForValueCon2.newValueLength,
    selectedCount = _getParamsForValueCon2.selectedCount,
    showInitialValue = _getParamsForValueCon2.showInitialValue,
    showNewValue = _getParamsForValueCon2.showNewValue,
    showValue = _getParamsForValueCon2.showValue,
    valueLength = _getParamsForValueCon2.valueLength;
  var displaySelectedValue = function displaySelectedValue() {
    if (showInitialValue) {
      if (initialValueLength === 1) {
        var initialValue = selectProps.allOptions.find(function (option) {
          return option.value === selectProps.initialValue[0];
        });
        return initialValue != null && initialValue.label ? initialValue.label : /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
          id: selectProps.initialValueCountTranslationKey,
          values: {
            count: initialValueLength
          }
        });
      }
      if (initialValueLength > 1) {
        return /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
          id: selectProps.initialValueCountTranslationKey,
          values: {
            count: initialValueLength
          }
        });
      }
    }
    if (showValue && valueLength === 1 && selectProps.value[0]) {
      return selectProps.value[0].label;
    }
    return showValue && /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
      id: selectProps.valueCountTranslationKey,
      values: {
        count: valueLength
      }
    });
  };
  var displayNewValue = function displayNewValue() {
    if (newValueLength === 1 && selectProps.value[0]) {
      return selectProps.value.find(function (selection) {
        return !selectProps.initialValue.includes(selection.value);
      }).label;
    }
    return /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
      id: selectProps.valueCountTranslationKey,
      values: {
        count: newValueLength
      }
    });
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: selectProps.classes.selectionContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(selectProps.classes.valuesContainer, {
      'no-wrap': selectProps.menuIsOpen
    })
  }, !!selectedCount && /*#__PURE__*/_react.default.createElement("div", {
    className: selectProps.classes.selectionValue
  }, /*#__PURE__*/_react.default.createElement(_material.Chip, {
    avatar: /*#__PURE__*/_react.default.createElement(_material.Avatar, null, showInitialValue ? initialValueLength : selectedCount),
    classes: {
      label: (0, _classnames.default)(selectProps.classes.chipLabel, {
        [selectProps.classes.chipLabelHide]: selectProps.menuIsOpen
      }),
      root: selectProps.classes.chip
    },
    color: showInitialValue ? 'secondary' : 'default',
    label: !selectProps.menuIsOpen && displaySelectedValue()
  })), showNewValue && showInitialValue && /*#__PURE__*/_react.default.createElement("div", {
    className: selectProps.classes.selectionValue
  }, /*#__PURE__*/_react.default.createElement(_material.Chip, {
    avatar: /*#__PURE__*/_react.default.createElement(_material.Avatar, null, newValueLength),
    classes: {
      label: (0, _classnames.default)(selectProps.classes.chipLabel, {
        [selectProps.classes.chipLabelHide]: selectProps.menuIsOpen
      }),
      root: selectProps.classes.chip
    },
    label: !selectProps.menuIsOpen && displayNewValue()
  }))), children);
}
function Menu(_ref9) {
  var children = _ref9.children,
    innerProps = _ref9.innerProps,
    selectProps = _ref9.selectProps;
  return /*#__PURE__*/_react.default.createElement(_material.Paper, (0, _extends2.default)({
    className: selectProps.classes.paper,
    square: true
  }, innerProps), children, selectProps.moreThanMaxOptions && /*#__PURE__*/_react.default.createElement(_material.Box, {
    clone: true,
    p: 1
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    color: "textSecondary",
    variant: "caption"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    defaultMessage: "Showing {maxOptions} out of {optionsLength} results",
    id: "select.text.moreThanMaxOptions",
    values: {
      maxOptions: selectProps.maxOptions,
      optionsLength: selectProps.optionsLength
    }
  }))));
}
function Input(_ref10) {
  var selectProps = _ref10.selectProps,
    props = (0, _objectWithoutProperties2.default)(_ref10, _excluded);
  return /*#__PURE__*/_react.default.createElement(_reactSelect.components.Input, (0, _extends2.default)({}, props, selectProps.inputProps));
}
function LoadingIndicator(_ref11) {
  var selectProps = _ref11.selectProps;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: selectProps.classes.loadingIndicator
  }, selectProps.loadingIndicator);
}
var components = {
  Control,
  Input,
  LoadingIndicator,
  Menu,
  MultiValue,
  NoOptionsMessage,
  Option,
  Placeholder,
  SingleValue,
  ValueContainer
};
var componentsWithChecboxes = {
  Control,
  Input,
  LoadingIndicator,
  Menu,
  MultiValue: Empty,
  NoOptionsMessage,
  Option: _OptionWithCheckbox.default,
  Placeholder,
  SingleValue,
  ValueContainer: ValueContainerWithChecboxes
};
function byLabel(a, b) {
  var labelA = a.label ? a.label.toUpperCase() : 0;
  var labelB = b.label ? b.label.toUpperCase() : 0;
  if (labelA > labelB) {
    return 1;
  }
  if (labelA < labelB) {
    return -1;
  }
  return 0;
}

// NB! Temporal fix until https://github.com/JedWatson/react-select/pull/4080 is merged
// This prevents react-select from focusing always first element
function useReactSelectFocusFix() {
  var selectRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    var _selectRef$current;
    if ((_selectRef$current = selectRef.current) != null && _selectRef$current.select) {
      selectRef.current.select.getNextFocusedOption = function () {
        return null;
      };
    }
  }, []);
  return selectRef;
}
function ReduxSelect(_ref12) {
  var _meta$initial, _meta$data;
  var autoFocus = _ref12.autoFocus,
    _ref12$canDeleteIniti = _ref12.canDeleteInitialValue,
    canDeleteInitialValue = _ref12$canDeleteIniti === void 0 ? true : _ref12$canDeleteIniti,
    children = _ref12.children,
    className = _ref12.className,
    closeMenuOnSelect = _ref12.closeMenuOnSelect,
    disabled = _ref12.disabled,
    fixedHeight = _ref12.fixedHeight,
    _ref12$fullWidth = _ref12.fullWidth,
    fullWidth = _ref12$fullWidth === void 0 ? true : _ref12$fullWidth,
    helperText = _ref12.helperText,
    id = _ref12.id,
    input = _ref12.input,
    _ref12$isClearable = _ref12.isClearable,
    isClearable = _ref12$isClearable === void 0 ? true : _ref12$isClearable,
    isMulti = _ref12.isMulti,
    label = _ref12.label,
    loadingIndicator = _ref12.loadingIndicator,
    _ref12$maxOptions = _ref12.maxOptions,
    maxOptions = _ref12$maxOptions === void 0 ? 50 : _ref12$maxOptions,
    meta = _ref12.meta,
    onChange = _ref12.onChange,
    _ref12$options = _ref12.options,
    options = _ref12$options === void 0 ? [] : _ref12$options,
    removeSelected = _ref12.removeSelected,
    showCheckboxes = _ref12.showCheckboxes,
    _ref12$showSelectAll = _ref12.showSelectAll,
    showSelectAll = _ref12$showSelectAll === void 0 ? false : _ref12$showSelectAll,
    _ref12$sortOptions = _ref12.sortOptions,
    sortOptions = _ref12$sortOptions === void 0 ? true : _ref12$sortOptions,
    _ref12$sortValue = _ref12.sortValue,
    sortValue = _ref12$sortValue === void 0 ? true : _ref12$sortValue,
    style = _ref12.style,
    other = (0, _objectWithoutProperties2.default)(_ref12, _excluded2);
  var classes = useStyles();
  var theme = (0, _material.useTheme)();
  var _useState = (0, _react.useState)(''),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    inputValue = _useState2[0],
    setInputValue = _useState2[1];
  var _useState3 = (0, _react.useState)(showSelectAll && isMulti && (meta == null ? void 0 : (_meta$initial = meta.initial) == null ? void 0 : _meta$initial.length) === options.length),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    allSelected = _useState4[0],
    setAllSelected = _useState4[1];
  var selectRef = useReactSelectFocusFix();
  var selectOptions = options.map(function (option) {
    return (0, _extends2.default)({}, option, {
      id: "".concat(id, "Option-").concat(option.value)
    });
  });
  var selectStyles = {
    clearIndicator: function clearIndicator(base) {
      return (0, _extends2.default)({}, base, {
        padding: 6
      });
    },
    container: function container(base) {
      return (0, _extends2.default)({}, base, fullWidth && {
        width: '100%'
      }, style);
    },
    dropdownIndicator: function dropdownIndicator(base) {
      return (0, _extends2.default)({}, base, {
        '&:hover': {
          color: 'hsl(0,0%,15%)'
        },
        padding: 6
      });
    },
    input: function input(base) {
      return (0, _extends2.default)({}, base, {
        color: theme.palette.text.primary,
        maxWidth: '100%',
        overflow: 'hidden'
      });
    }
  };
  var handleOnChange = function handleOnChange(val) {
    if (typeof onChange === 'function') {
      onChange(val);
    }
    return input.onChange(val);
  };
  var onChangeFunc = function onChangeFunc(val) {
    if (isMulti && allSelected && (val == null ? void 0 : val.length) !== options.length) {
      setAllSelected(false);
    }
    if (!canDeleteInitialValue && isMulti && meta.initial) {
      var newValue = (0, _lodash.union)(meta.initial.map(function (initialValue) {
        return selectOptions.find(function (opt) {
          return opt.value === initialValue;
        });
      }), val).map(function (opt) {
        return opt.value;
      });
      return handleOnChange(newValue);
    }
    if (isClearable && (!val || val.length < 1)) {
      return handleOnChange(null);
    }
    if (isMulti && val != null && val.find(function (opt) {
      return opt.selectAll;
    })) {
      if (allSelected) {
        setAllSelected(false);
        return handleOnChange(null);
      }
      setAllSelected(true);
      return handleOnChange(options.map(function (_ref13) {
        var value = _ref13.value;
        return value;
      }));
    }
    return handleOnChange(isMulti ? val.map(function (opt) {
      return opt.value;
    }) : val == null ? void 0 : val.value);
  };
  var error = meta.touched && (meta.error || !meta.modifiedSinceLastSubmit && (meta == null ? void 0 : (_meta$data = meta.data) == null ? void 0 : _meta$data.submitError) || meta.warning);
  var helperTextValue = error || helperText;
  var textFieldId = "".concat(id, "TextField");
  var hideSelectedOptions = !showCheckboxes && isMulti;
  var visibleOptions = hideSelectedOptions ? selectOptions.filter(function (a) {
    return !input.value.includes(a.value);
  }) : selectOptions;
  var filteredOptions = inputValue ? visibleOptions.filter(function (curr) {
    return curr.label.toLowerCase().includes(inputValue.toLowerCase());
  }) : visibleOptions;
  var sortedOptions = sortOptions ? filteredOptions.sort(byLabel) : filteredOptions;
  var moreThanMaxOptions = sortedOptions.length > maxOptions;
  var truncatedOptions = moreThanMaxOptions ? sortedOptions.slice(0, maxOptions) : sortedOptions;
  return /*#__PURE__*/_react.default.createElement(_reactSelect.default, (0, _extends2.default)({
    ref: selectRef,
    allOptions: selectOptions,
    allSelected: allSelected,
    "aria-describedby": textFieldId,
    canDeleteInitialValue: canDeleteInitialValue,
    classes: classes,
    className: className,
    closeMenuOnSelect: typeof closeMenuOnSelect === 'undefined' ? !isMulti : closeMenuOnSelect,
    components: showCheckboxes ? componentsWithChecboxes : components,
    error: !!error,
    fixedHeight: fixedHeight,
    hideSelectedOptions: hideSelectedOptions,
    id: id,
    initialValue: meta.initial,
    inputValue: inputValue,
    isClearable: isClearable,
    isDisabled: disabled,
    isLoading: !!loadingIndicator,
    isMulti: isMulti,
    loadingIndicator: loadingIndicator,
    maxOptions: maxOptions,
    moreThanMaxOptions: moreThanMaxOptions,
    onBlur: function onBlur() {
      return input.onBlur();
    },
    onChange: onChangeFunc,
    onInputChange: function onInputChange(val, _ref14) {
      var action = _ref14.action;
      if (action !== 'set-value') {
        setInputValue(val);
      }
    },
    openMenuOnFocus: true,
    options: [].concat((0, _toConsumableArray2.default)(showSelectAll && !(allSelected && !showCheckboxes) && isMulti && [{
      id: "".concat(id, "Option-SelectAll"),
      label: _FormattedMessage2 || (_FormattedMessage2 = /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        defaultMessage: "All",
        id: "select.action.selectAll"
      })),
      selectAll: true
    }] || []), (0, _toConsumableArray2.default)(truncatedOptions)),
    optionsLength: sortedOptions == null ? void 0 : sortedOptions.length,
    placeholder: input.placeholder || '',
    showCheckboxes: showCheckboxes,
    styles: selectStyles,
    tabSelectsValue: false,
    TextFieldProps: (0, _extends2.default)({
      error: !!error,
      fullWidth,
      helperText: helperTextValue,
      id: textFieldId,
      label,
      name: input.name
    }, other.TextFieldProps),
    value: Array.isArray(input.value) ? input.value.map(function (val) {
      return selectOptions.find(function (opt) {
        return opt.value === val;
      });
    }).sort(sortValue ? byLabel : function () {
      return 0;
    }) : selectOptions.find(function (opt) {
      return opt.value === input.value;
    }) || null
  }, other));
}